module.exports = __webpack_public_path__ + "img/header-phone-icon.c22883d2.svg";